var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 48,
    viewBox: "0 0 96 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1137_29303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.6655 20.21V31.9452H78.4751V23.7132H74.4403V31.9452H70.2499V20.2092H82.6655V20.21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6445 32.3648C65.3957 32.3648 68.1813 30.0648 68.1813 26.578C68.1813 23.2032 66.1261 21.012 62.6913 21.012C61.1061 21.012 59.7981 21.57 58.8129 22.5328C59.0481 20.5428 60.7309 19.09 62.5837 19.09C63.0113 19.09 66.2305 19.0832 66.2305 19.0832L68.0509 15.5996C68.0509 15.5996 64.0093 15.6916 62.1305 15.6916C57.8377 15.7664 54.9381 19.6684 54.9381 24.4076C54.9381 29.9288 57.7661 32.3648 61.6445 32.3648ZM61.6673 24.0976C63.0601 24.0976 64.0257 25.0128 64.0257 26.5776C64.0257 27.986 63.1677 29.1464 61.6673 29.1496C60.2321 29.1496 59.2665 28.0744 59.2665 26.6016C59.2665 25.0364 60.2321 24.0976 61.6673 24.0976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5272 28.016C51.5272 28.016 50.5376 28.5864 49.0596 28.6944C47.3604 28.7448 45.8464 27.6716 45.8464 25.7648C45.8464 23.9048 47.1824 22.8388 49.0168 22.8388C50.1416 22.8388 51.6296 23.6184 51.6296 23.6184C51.6296 23.6184 52.7184 21.6204 53.2824 20.6212C52.2496 19.8384 50.874 19.4092 49.274 19.4092C45.236 19.4092 42.1084 22.042 42.1084 25.7412C42.1084 29.4876 45.048 32.0592 49.274 31.9816C50.4552 31.9376 52.0848 31.5228 53.078 30.8848L51.5272 28.016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.448L5.81279 20.838V27.1756L0.00679999 37.5452L0 10.448Z",
    fill: "#5B57A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3188 17.0568L27.7656 13.7184L38.9128 13.708L22.3188 23.8736V17.0568Z",
    fill: "#D90751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.288 10.3868L22.3188 24.1428L16.4924 20.5628V0L22.288 10.3868Z",
    fill: "#FAB718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9128 13.7084L27.7652 13.7188L22.288 10.3868L16.4924 0L38.9128 13.7084Z",
    fill: "#ED6F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3188 37.6027V30.9287L16.4924 27.4167L16.4956 47.9999L22.3188 37.6027Z",
    fill: "#63B22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.752 34.2948L5.81239 20.838L0 10.448L38.8892 34.2812L27.752 34.2948Z",
    fill: "#1487C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.496 48L22.3184 37.6029L27.7516 34.2948L38.8887 34.2812L16.496 48Z",
    fill: "#017F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00683594 37.5452L16.54 27.4172L10.9816 24.0068L5.81283 27.1756L0.00683594 37.5452Z",
    fill: "#984995"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1137_29303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.5999,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbp);
export default __webpack_public_path__ + "static/media/sbp.fbdae9390c1e50e027e9ad82edb1e4b6.svg";
export { ForwardRef as ReactComponent };